<script setup lang="ts">
import { useClipboard } from '@vueuse/core'
import { useUserInfo } from '@mp/hooks'

import { ElMessage } from 'element-plus'
import { IconFont } from '@mp/component'
import { useQuery } from '@tanstack/vue-query'

import { mchReservedQuery } from '@mp/api/sdpMerchant/ReservedController.js'
import { onMounted } from 'vue'
import { setUser } from '@sentry/vue'

const { copy } = useClipboard()
const { userInfo, isHeadOffice } = useUserInfo()

// #查询预留信息
const { data: reservedData } = useQuery({
  queryKey: ['mch/reserved/query'],
  queryFn: () => mchReservedQuery(),
  select: res => res?.data,
})

function handleCopyInfp() {
  copy(`商户简称:${userInfo.value?.merchantShortName ?? '-'}
商户ID: ${userInfo.value?.merchantId ?? '-'}
商户名称: ${userInfo.value?.merchantName ?? '-'}
账号名称: ${userInfo.value?.operatorName ?? '-'}
登录账号: ${userInfo.value?.loginAccount ?? '-'}
上次登录时间: ${userInfo.value?.lastLoginTime ?? '-'}
`)
  ElMessage.success('复制成功')
}

onMounted(() => {
  setUser({
    merchantId: userInfo.value?.merchantId,
    merchantName: userInfo.value?.merchantName,
    merchantShortName: userInfo.value?.merchantShortName,
    operatorName: userInfo.value?.operatorName,
    loginAccount: userInfo.value?.loginAccount,
  })
})
</script>

<template>
  <div class="bg-white rounded-lg p-4">
    <div class="flex">
      <img class="w-[48px] h-[48px] rounded-full block mr-3" src="/avatar-1.svg" alt="">
      <div class="flex-1">
        <h3 class="text-base text-black flex items-start font-medium">
          {{ userInfo?.merchantShortName || userInfo?.merchantName || '--' }}
          <el-tag v-if="isHeadOffice" type="primary" effect="plain" round class="ml-1 translate-y-[2px]" size="small">
            总部
          </el-tag>

          <el-button
            v-if="userInfo?.merchantShortName" type="primary" link class="ml-auto translate-y-[1px]"
            @click="handleCopyInfp"
          >
            复制
          </el-button>
        </h3>

        <p class="text-n-80 text-sm mt-1 flex">
          {{ userInfo?.merchantId }}&nbsp;|&nbsp;<span class="truncate flex-1">{{ userInfo?.merchantName }}</span>
        </p>
      </div>
    </div>

    <el-divider style="margin-bottom: 18px;" />
    <div class="space-y-4 text-n-400 text-sm">
      <p class="flex items-center leading-none">
        <IconFont type="icon-phone" class="text-n-90 text-lg mr-2 -mt-[2px] leading-none" />
        登录账号：{{ userInfo?.loginAccount }}
        <el-tag v-if="userInfo?.operatorType === 'default'" class="ml-2" type="warning" size="small">
          管理员
        </el-tag>
      </p>
      <p class="flex items-center leading-none">
        <IconFont type="icon-history" class="text-n-90 text-lg mr-2 -mt-[2px] leading-none" /> 上次登录时间：{{
          userInfo?.lastLoginTime }}
      </p>

      <div class="flex items-center leading-none flex-wrap">
        <IconFont type="icon-document-text" class="text-n-90 text-lg mr-2 -mt-[2px] leading-none" />
        <span>预留信息：</span>
        <template v-if="!reservedData">
          <IconFont type="icon-exclamation-circle" class="text-warn ml-1" />
          <span class="text-n-400">未设置</span>
          <el-popover
            placement="top-start"
            title="预留信息"
            :width="200"
            trigger="hover"
            content="预留信息可以有效的保护账号的安全。"
          >
            <template #reference>
              <IconFont type="icon-yiwen1" class="text-n-90 ml-1" />
            </template>
          </el-popover>
        </template>
        <p v-else class="leading-5">
          {{ reservedData }}
        </p>
      </div>
    </div>
  </div>
</template>
